import { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import classes from "./divider.scss";

const RentableGroupFormDivider: FC<
  DetailedHTMLProps<HTMLAttributes<HTMLHRElement>, HTMLHRElement>
> = (props) => <hr className={classes.root} {...props} />;

export default RentableGroupFormDivider;
